import styled, { css } from 'styled-components';
import { getMediaQuery, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import { Box, Heading, HorizontalRule as HorizontalRuleElement, Text as TextElement } from '../../atoms';
const variationsList = {
  default: css`
    flex-direction: column;
    word-break: break-word;
    min-width: 280px;
  `,
  flex: css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    ${getMediaQuery('small')} {
      justify-content: left;
    }
  `,
  inline: css`
    display: inline;
    font-size: inherit;
    line-height: normal;
  `
};
const variationsItem = {
  flex: css`
    display: inline-block;
    padding: ${themeGet('space.3')}px ${themeGet('space.2')}px;
    ${getMediaQuery('small')} {
      width: 150px;
      padding: unset;
    }
  `,
  inline: css`
    display: inline-block;
    margin-right: ${themeGet('space.4')}px;
    font-size: inherit;
    & a {
      display: inline-block;
      font-size: inherit;
      line-height: normal;
    }
  `
};
const variationTitle = {
  default: css`
    color: ${props => getTextColor('base')(props)};
    padding-bottom: ${themeGet('space.3')}px;
    line-height: normal;
  `,
  inline: css`
    display: inline-block;
    margin-right: ${themeGet('space.3')}px;
    font-size: inherit;
  `
};
export const Container = styled(Box).attrs(props => Object.assign({
  p: 3,
  textAlign: 'left',
  borderRadius: 'default'
}, props))``;
export const Title = styled(Heading)`
  ${props => variationTitle[props.variation] || variationTitle.default};
`;
export const HorizontalRule = styled(HorizontalRuleElement)`
  ${getMediaQuery('small')} {
    display: none;
  }
`;
export const List = styled.ul`
  list-style-position: inside;
  display: flex;
  justify-content: space-around;
  ${props => variationsList[props.variation] || variationsList.default};
`;
export const Item = styled(TextElement).attrs(() => ({
  forwardedAs: 'li',
  fontSize: 2,
  color: 'scratched',
  lineHeight: 'big'
}))`
  list-style-type: ${({
  hideListPoint
}) => hideListPoint ? 'none' : 'disc'};
  ${props => variationsItem[props.variation] || variationsItem.default};
`;